import React from 'react';
import '../App.css';

function Contact() {
  return (
      <div className="App">
        <header className="App-header">
          Contact: info@huurhuishunter.nl
        </header>
      </div>
  );
}

export default Contact;
